module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('b', [_vm._v("Books for Wiser Living recommended by "), _c('i', [_vm._v("Mother Earth News")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODAY, MORE THAN EVER BEFORE")]), _vm._v(", our society is seeking ways to live more conscientiously. To help bring you the very best inspiration and information about greener, more sustainable lifestyles, "), _c('i', [_vm._v("Mother Earth News")]), _vm._v(" is recommending select New Society Publishers books to its readers. For more than 30 years, "), _c('i', [_vm._v("Mother Earth")]), _vm._v(" has been North America’s “Original Guide to Living Wisely,” creating books and magazines for people with a passion for self-reliance and a desire to live in harmony with nature. Across the countryside and in our cities, New Society Publishers and "), _c('i', [_vm._v("Mother Earth")]), _vm._v(" are leading the way to a wiser, more sustainable world. For more information, please visit "), _c('a', {
    attrs: {
      "href": "http://MotherEarthNews.com",
      "target": "_blank"
    }
  }, [_vm._v("MotherEarthNews.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f96b47f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Books.vue
// module id = 75
// module chunks = 0